import { privateGet} from '../../../../methods/get';
import { IObterListaOpcoesLayout, IObterListaOpcoesLayoutCliente } from '../../../../models/Relatorio';
const basePath = "/relatorio"

export const obterListaOpcoesLayoutRelatoriosProvisionamento = () => {
    return privateGet<IObterListaOpcoesLayout[]>(`${basePath}/obterlistaopcoesrelatorioprovisionamento`)
}